var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 102,
    viewBox: "0 0 91 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2162 5.59047C43.0645 3.36861 47.8059 3.36861 51.6543 5.59047L81.6514 22.9093C85.4998 25.1312 87.8705 29.2373 87.8705 33.6811V68.3187C87.8705 72.7624 85.4998 76.8686 81.6514 79.0905L51.6543 96.4093C47.8059 98.6312 43.0645 98.6312 39.2162 96.4093L9.21908 79.0905C5.3707 76.8686 3 72.7624 3 68.3187V33.6811C3 29.2373 5.3707 25.1312 9.21908 22.9093L39.2162 5.59047Z",
    fill: "#4374A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1543 2.99239L83.1514 20.3112C87.928 23.069 90.8705 28.1655 90.8705 33.6811V68.3187C90.8705 73.8342 87.928 78.9308 83.1514 81.6886L53.1543 99.0074C48.3777 101.765 42.4927 101.765 37.7162 99.0074L7.71908 81.6886C2.9425 78.9308 0 73.8342 0 68.3187V33.6811C0 28.1655 2.9425 23.069 7.71908 20.3112L37.7162 2.99239C42.4927 0.234632 48.3777 0.234632 53.1543 2.99239ZM51.6543 5.59047C47.8059 3.36861 43.0645 3.36861 39.2162 5.59047L9.21908 22.9093C5.3707 25.1312 3 29.2373 3 33.6811V68.3187C3 72.7624 5.3707 76.8686 9.21908 79.0905L39.2162 96.4093C43.0645 98.6312 47.8059 98.6312 51.6543 96.4093L81.6514 79.0905C85.4998 76.8686 87.8705 72.7624 87.8705 68.3187V33.6811C87.8705 29.2373 85.4998 25.1312 81.6514 22.9093L51.6543 5.59047Z",
    fill: "#4374A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2162 5.59047C43.0645 3.36861 47.8059 3.36861 51.6543 5.59047L81.6514 22.9093C85.4998 25.1312 87.8705 29.2373 87.8705 33.6811V68.3187C87.8705 72.7624 85.4998 76.8686 81.6514 79.0905L51.6543 96.4093C47.8059 98.6312 43.0645 98.6312 39.2162 96.4093L9.21908 79.0905C5.3707 76.8686 3 72.7624 3 68.3187V33.6811C3 29.2373 5.3707 25.1312 9.21908 22.9093L39.2162 5.59047Z",
    fill: "#87E1FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1514 25.5074L50.1543 8.18855C47.2341 6.50258 43.6363 6.50258 40.7162 8.18855L10.7191 25.5074C7.7989 27.1933 6 30.3091 6 33.6811V68.3187C6 71.6907 7.7989 74.8064 10.7191 76.4924L40.7162 93.8112C43.6363 95.4972 47.2341 95.4972 50.1543 93.8112L80.1514 76.4924C83.0716 74.8064 84.8705 71.6907 84.8705 68.3187V33.6811C84.8705 30.3091 83.0716 27.1933 80.1514 25.5074ZM51.6543 5.59047C47.8059 3.36861 43.0645 3.36861 39.2162 5.59047L9.21908 22.9093C5.3707 25.1312 3 29.2373 3 33.6811V68.3187C3 72.7624 5.3707 76.8686 9.21908 79.0905L39.2162 96.4093C43.0645 98.6312 47.8059 98.6312 51.6543 96.4093L81.6514 79.0905C85.4998 76.8686 87.8705 72.7624 87.8705 68.3187V33.6811C87.8705 29.2373 85.4998 25.1312 81.6514 22.9093L51.6543 5.59047Z",
    fill: "#FFFBF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2334 51.4744H35V50.4744H54.2334V51.4744Z",
    fill: "#4374A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1204 74V28H46.1204V74H43.1204Z",
    fill: "#D8367D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.45776,
    ry: 4.48527,
    transform: "matrix(-1 -8.79623e-08 -8.68866e-08 1 44.4578 30.5148)",
    fill: "#4374A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5116 33.9571L47.2945 28.0674L44.5286 29.9412L41.9035 27.9841L44.5116 33.9571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerT);
export default __webpack_public_path__ + "static/media/LOWER_T.4688f45e0b2724d9ea0e90963c8e96c8.svg";
export { ForwardRef as ReactComponent };